@if (!missingData) {
  <div class="st-drawer-wrapper">
    <a href=""></a>
    <div class="st-drawer-header">
      <span class="text-header-16 text-semibold">{{(nzData.editingElement ? 'Editar' : 'Crear') + ' ' + nzData.maestroName}}</span>
      <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
    </div>

    <form [formGroup]="dynamicForm" class="st-drawer-content st-form" nz-form>
      <div *ngFor="let column of nzData.columnsData">
        <!--Este if es para oculltar columnas en el drawer-->
        @if (column.pathData && column.pathData.name !== 'id' && column.noVisibleInForm!==false) {
          <div [ngSwitch]="column.pathData.type || 'text'">

            <!-- Input de texto -->
            <div *ngSwitchCase="'text'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <input type="text" nzSize="large" nz-input [formControlName]="column.pathData.name" />
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Textarea para textos largos -->
            <div *ngSwitchCase="'textarea'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <textarea nzSize="large" nz-input [formControlName]="column.pathData.name" 
                           [nzAutosize]="{ minRows: 5, maxRows: 10 }"
                           style="white-space: pre-wrap; word-wrap: break-word;"></textarea>
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Input numérico -->
            <div *ngSwitchCase="'number'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  @if (column.pathData.name === 'amount' && shouldShowPercent()) {
                    <div class="input-with-percent">
                      <input type="number" nzSize="large" nz-input [formControlName]="column.pathData.name" />
                      <span class="percent-symbol">%</span>
                    </div>
                  } @else {
                    <input type="number" nzSize="large" nz-input [formControlName]="column.pathData.name" />
                  }
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Input currency (se maneja como number) -->
            <div *ngSwitchCase="'currency'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <input type="number" nzSize="large" nz-input [formControlName]="column.pathData.name" step="0.01" />
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Input money-rate (se maneja como number) -->
            <div *ngSwitchCase="'money-rate'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <input type="number" nzSize="large" nz-input [formControlName]="column.pathData.name" step="0.000001" />
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Selector de fecha -->
            <div *ngSwitchCase="'date'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">{{ column.name }}</nz-form-label>
                <nz-form-control>
                  <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                    <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100"
                                    [formControlName]="column.pathData.name"
                                    nzFormat="dd-MM-yyyy"
                    ></nz-date-picker>
                  </nz-input-group>
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Selector dropdown -->
            <div *ngSwitchCase="'select'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control 
                  [nzErrorTip]="getValidatorError(column)" 
                  nzHasFeedback>
                  @if (column.optionList && column.optionList.length > 0) {
                    <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" 
                               [nzAllowClear]="!column.readonly"
                               [nzDisabled]="column.readonly"
                               nzSize="large"
                               nzShowSearch [formControlName]="column.pathData.name">
                      <nz-option *ngFor="let opt of column.optionList" [nzValue]="opt.id" [nzLabel]="opt.name || opt.role">
                      </nz-option>
                    </nz-select>
                  } @else {
                    <nz-select 
                               [nzDisabled]="true"
                               nzSize="large"
                               [formControlName]="column.pathData.name"
                               nzPlaceHolder="No hay opciones disponibles">
                      <nz-option nzValue="" nzLabel="No hay opciones disponibles" nzDisabled></nz-option>
                    </nz-select>
                    <div class="text-label-12 color-grey-9" style="margin-top: 4px;">
                      Este campo es opcional cuando no hay opciones disponibles
                    </div>
                  }
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Selector avatar -->
            <div *ngSwitchCase="'avatar-select'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <app-avatar-select [formControlName]="column.pathData.name"
                                     [options]="getPartnerOptions(column)"
                  ></app-avatar-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <!-- Selector icon -->
            <div *ngSwitchCase="'icon-select'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
                  <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                             [formControlName]="column.pathData.name"
                             nzPlaceHolder="Selecciona el Icono..." [nzDropdownStyle]="{width: '264px'}"
                             nzDropdownClassName="grid-dropdown" [nzOptionOverflowSize]="43"
                             [nzDropdownMatchSelectWidth]="false" [nzCustomTemplate]="iconSelectTpmpl">
                    <nz-option *ngFor="let icon of column.optionList" [nzLabel]="icon" [nzValue]="icon" nzCustomContent>
                      <button nz-button nzShape="circle" class="text-btn-16 flex-center" nzType="text" style="color: inherit">
                        <app-st-icon [name]="icon"></app-st-icon>
                      </button>
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Selector booleano -->
            <div *ngSwitchCase="'boolean'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  @if (column.checkboxOnTable) {
                    <nz-switch [formControlName]="column.pathData.name" nzSize="default"></nz-switch>
                  } @else {
                    <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                               nzShowSearch [formControlName]="column.pathData.name">
                      <nz-option [nzValue]=true [nzLabel]="'Si'">
                      </nz-option>
                      <nz-option [nzValue]=false [nzLabel]="'No'">
                      </nz-option>
                    </nz-select>
                  }
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Selector dropdown multi-select-->
            <div *ngSwitchCase="'multi-select'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzAllowClear nzSize="large"
                             class="custom-select" nzMode="multiple" nzShowSearch [formControlName]="column.pathData.name"
                             [compareWith]="compareFn">
                    <nz-option *ngFor="let opt of getFilteredMemberListOptions(column)" [nzValue]="opt" [nzLabel]="opt.name">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>


            <!-- Input de imagen -->
            <div *ngSwitchCase="'image'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <input type="hidden" nzSize="large" nz-input [formControlName]="column.pathData.name" />
                  <nz-upload #uploadComponent nzType="drag"
                    [nzShowUploadList]="false"
                    [nzMultiple]="false"
                    [nzCustomRequest]="customUpload"
                    (nzChange)="handleUploadChange($event,column)"
                    nzAccept="image/*">
                    @if (!avatarUrl) {
                     <div class="ant-upload-drag-icon">
                      <app-st-icon [bold]="true" name="upload"></app-st-icon>
                    </div>
                    <!-- <nz-icon class="upload-icon" [nzType]="loading ? 'loading' : 'plus'" /> -->
                      <!-- <div class="ant-upload-text">Upload</div> -->
                    } @else {
                    <img [src]="avatarUrl" class="avatar-uploader"/>
                    }

                    <!-- <p class="ant-upload-text">{{ (isMobile$ | async) ? 'Pulsa para subir la imagen.' : 'Arrastra a esta ventana o haz
                      click para subir la imagen.' }}</p> -->
                  </nz-upload>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div *ngSwitchCase="'color'">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" [nzRequired]="hasRequiredValidator(column)">{{ column.name }}</nz-form-label>
                <nz-form-control [nzErrorTip]="getValidatorError(column)" nzHasFeedback>
                  <nz-color-picker [formControlName]="column.pathData.name" nzShowText/>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        }
      </div>
    </form>

    <div class="st-drawer-footer">
      <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar</button>
      <button [disabled]="!isFormValid()" (click)="onSubmit()"
              class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="!loading" class="prefix" [name]="nzData.editingElement ? 'edit' : 'add'" [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="loading" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>{{nzData.editingElement ? 'Guardar' : 'Crear'}}</span>
      </button>
    </div>
  </div>
} @else {
  <h3>No se puede crear/editar datos de este maestro porque no se tienen datos para configurar la propiedad {{missingData}}.
    Por favor llena la tabla correspondiente.</h3>
}

<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>

<ng-template #emtySuffixTmpl>
</ng-template>

<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>


<ng-template #iconSelectTpmpl let-selected>
  <app-st-icon [name]="selected.nzValue"></app-st-icon>
</ng-template>
